import { createApp } from 'vue'
import { loadTranslations } from '@/js/global/vue-i18n'
import Login from '@/components/home/views/Login.vue'

const app = createApp(Login)

loadTranslations(app).then(() => {
    app.mount('#login-vue')
})
